






import { Component, Vue } from 'vue-property-decorator'
import { membershipState } from '../../store/modules/MembershipState'
import RegisteredUserInfo from '../../modules/class/RegisteredUserInfo'
import { getUserInfo } from '../../modules/util/SapUtil'

@Component({})
export default class GetUserName extends Vue {
  private readonly vueid = 'vue_get_user_name'

  // ------------------------------------------------------------------------------------------------
  // data

  // -------------------------------------------------------------------------------------------------------------------
  // getter
  get userInfo(): RegisteredUserInfo {
    return membershipState.userInfo
  }

  // ------------------------------------------------------------------------------------------------
  // hooks
  private mounted() {
    if (document.getElementById(this.vueid) !== null) {
      // 姓名が両方ともない場合のみ取得する
      if (
        membershipState.userInfo.firstname === '' &&
        membershipState.userInfo.lastname === ''
      ) {
        getUserInfo()
      }
    }
  }

  // ------------------------------------------------------------------------------------------------
  // methods
}
